import React from 'react'
import Link from 'components/Link'
import './_homeFact.scss';

export default (props) => {
  return (
    <div className="home-fact">
      <Link to={props.path}>
        <div className="text-center">
          <h2 className="h3 text-color-title">{props.title}</h2>
          <p className="text-color-subtitle">{props.text}</p>
        </div>
      </Link>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/index/_homeFact.js